import { PaymentState } from '../../generated-api';
import type { PaymentTrackingState } from '../context/TerminalStore';
import { useTerminalStore } from '../context/TerminalStore';
import { UUID_REGEX } from '../constants/payment';
import type { CartDto } from '../../generated-api';

interface PaymentSubscriptionArgs {
  paymentReference: string;
  paymentMethodId: string;
  cart?: CartDto;
  onCompleted: (state: typeof PaymentState.SUCCEEDED | typeof PaymentState.FAILED) => void;
}

const subscribe = ({ paymentReference, paymentMethodId, cart, onCompleted }: PaymentSubscriptionArgs): boolean => {
  if (!paymentReference || UUID_REGEX.test(paymentReference)) {
    return false;
  }

  const terminalActions = useTerminalStore.getState().actions;
  terminalActions.trackPayment(paymentMethodId, paymentReference, cart);

  const unsub = terminalActions.subscribeToPayment(paymentReference, (state: PaymentTrackingState) => {
    if (state !== 'AUTHORISED' && state !== 'FAILED') {
      return;
    }

    unsub();
    // Always clear store state first — onCompleted may hold a stale closure
    // If the subscribing component unmounted (e.g. navigated away).
    terminalActions.clearPayment(paymentReference);

    const paymentState = state === 'AUTHORISED' ? PaymentState.SUCCEEDED : PaymentState.FAILED;
    onCompleted(paymentState);
  });

  return true;
};

export function usePaymentSubscription() {
  return subscribe;
}
